import { ArrowLeftIcon } from 'lucide-react'

import { Button } from 'slab'

interface BackButtonProps {
  onClick: () => void;
  label?: string;
}

export function BackButton ({ onClick, label = 'Back to all medical plans' }: BackButtonProps) {
  return (
    <Button
      leftIcon={ArrowLeftIcon}
      size='large'
      variant='tertiary-deemphasized'
      onClick={onClick}
    >
      {label}
    </Button>
  )
}
